import React, { useState, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDropzone } from 'react-dropzone';
import { PDFDocument } from 'pdf-lib';
import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
// import '../App.css';
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`[17];

const FilePage = () => {
    const navigate = useNavigate();
    const [fileDetails, setFileDetails] = useState(null);
    const [fileUrl, setFileUrl] = useState(null);

    useEffect(() => {
        // Get user data from localStorage
        const user = JSON.parse(localStorage.getItem('user'));
        if (!user) {
            navigate('/login');
        }

        // Fetch print history from your backend
        // fetchPrintHistory(user.id);
    }, [navigate]);

    const handleSubmit = () => {
        navigate('/print-2', { state: { fileDetails } });
    };

    const onDrop = useCallback(async (acceptedFiles) => {
        const file = acceptedFiles[0];
        if (file) {
            const url = URL.createObjectURL(file);
            const fileData = await file.arrayBuffer();
            const pdfDoc = await PDFDocument.load(fileData);
            const pages = pdfDoc.getPages();
            const firstPage = pages[0];
            const { width, height } = firstPage.getSize();

            setFileDetails({
                name: file.name,
                size: file.size,
                pageCount: pdfDoc.getPageCount(),
                width,
                height,
            });
            setFileUrl(url);
        }
    }, []);
    const { getRootProps, getInputProps } = useDropzone({ onDrop, accept: '.pdf' });

    return (
        <div style={styles.mainContent}>
            <div style={styles.parseInfo}>
                <div {...getRootProps({ style: styles.dropzone })}>
                    <input {...getInputProps()} />
                    <p>Drag 'n' drop a PDF file here, or click to select one</p>
                </div><br /><br />
                {fileDetails && (
                    <div>
                        <p style={styles.fileName}>{fileDetails.name}</p>
                        <p><strong>&emsp;File Size:</strong> {(fileDetails.size / 1024 / 1024).toFixed(4)} MB</p>
                        <p><strong>&emsp;Page Count:</strong> {fileDetails.pageCount}</p>
                        <p><strong>&emsp;Width:</strong> {fileDetails.width / 72} in</p>
                        <p><strong>&emsp;Height:</strong> {fileDetails.height / 72} in</p>
                        <button id="submit-button" onClick={handleSubmit} disabled={!fileDetails}>Next</button>
                    </div>
                )}

            </div>
            {fileUrl && (
                <div style={styles.pdfPreview}>
                    <iframe
                        src={fileUrl}
                        width="100%"
                        height="500px"
                        title="PDF Preview"
                    />
                </div>
            )}

        </div>
    )
};

// styles
const styles = {
    mainContent: {
        display: 'flex',
        width: '100%',
        // minHeight: '100vh',
        gap: '20px'
    },
    parseInfo: {
        flex: '1',
        padding: '20px',
        maxWidth: '50%'
    },
    pdfPreview: {
        flex: '1',
        padding: '20px',
        maxWidth: '50%'
    },
    dropzone: {
        border: '2px dashed #cccccc',
        borderRadius: '4px',
        padding: '20px',
        textAlign: 'center',
        cursor: 'pointer'
    },
    fileName: {
        fontWeight: 'bold',
        fontSize: '20px',
        color: '#333333'
    }
};


export default FilePage;